/* eslint-disable jsx-a11y/alt-text */
function NoImage() {
  return (
    <img width={"100px"} src={`${process.env.REACT_APP_APP_URL}assets/images/no-image.png`} className='img-fluid shadow-4' />
  );
}

export default NoImage;